<template lang="pug">
div
  e-z-toolbar(
    :title="'Services'",
    @sectionSelected="openSection($event)",
    @allSelected="openRestaurant($event)"
  )
  v-container.pa-0(fluid)
    v-row(justify-left, no-gutters)
      v-col(
        v-for="group in serviceGroups",
        :key="group.name",
        cols="12",
        xs="12",
        sm="6",
        md="4",
        lg="3",
        xl="2"
      )
        v-sheet(color="grey lighten-2")
          v-row(no-gutters)
            v-col
              .pl-3.pr-3
                div(style="float:left")
                  v-icon(small) mdi-plus-box-multiple
                  strong.pl-2 {{ group.name }}: ({{ group.services.length }})
                //
                  In case required for tools <div v-if="group.isPrintable" style="float:right">
                  <v-icon small>print</v-icon>
                  <strong>Print</strong>
                  </div>
          v-row(no-gutters)
            v-col
              v-list.pa-0(
                v-for="service in group.services",
                :key="service.title",
                justify-left
              )
                v-divider
                v-list-item
                  v-list-item-content.pa-0
                    v-list-item-title
                      strong {{ service.name }} - {{ service.customerName || service.mobile }}
                    v-list-item-subtitle
                      span
                        | [
                        v-icon(small, color="green lighten-1") mdi-send
                        code
                          | {{  sectionOrders.filter(o=&gt;o._serviceKey==service.id &amp;&amp; o.status===STATUSES.QUEUED).length  }}
                        v-icon(small, color="green lighten-1") mdi-play
                        code
                          | {{  sectionOrders.filter(o=&gt;o._serviceKey==service.id &amp;&amp; o.status===STATUSES.PREPON).length  }}
                        v-icon(small, color="green lighten-1") mdi-check
                        code
                          | {{  sectionOrders.filter(o=&gt;o._serviceKey==service.id &amp;&amp; o.status===STATUSES.READY).length  }}
                        v-icon(small, color="blue lighten-1") mdi-play
                        code
                          | {{  sectionOrders.filter(o=&gt;o._serviceKey==service.id &amp;&amp; o.status===STATUSES.INTRANSIT).length  }}
                        v-icon(small, color="blue lighten-1") mdi-check
                        code
                          | {{  sectionOrders.filter(o=&gt;o._serviceKey==service.id &amp;&amp; o.status===STATUSES.SERVED).length  }}
                        v-icon(small, color="blue lighten-1") mdi-check-all
                        code
                          | {{  sectionOrders.filter(o=&gt;o._serviceKey==service.id &amp;&amp; o.status===STATUSES.CLEARED).length  }}
                        | ]
                  v-list-item-action
                    v-list-item-action-text
                      span(
                        v-if="myFeatures.eligibleFeatures.includes('TIMER') && service.status != STATUSES.PAID",
                        :key="ageKey",
                        v-bind:class="{ blink: isDelayed(service) }"
                      ) {{ getAge(service) }}m
                      span(v-else)
                        | {{  moment(service.status === STATUSES.PAID ? service.lastUpdatedTS : service.createdTS).format(&apos;LT&apos;)  }}
                    v-icon(@click="vibrate(); editItem(service)") mdi-pencil
          v-divider
          //
            </v-card-text>
            </v-card>
  //
    <v-btn fab small fixed bottom right color="grey">
    <v-icon @click.stop="vibrate();addService()">add</v-icon>
    </v-btn>
  service-dialog(
    v-if="mode.serviceDialog",
    :editedItem="editedItem",
    :mode="mode",
    @save="save($event)",
    @delete="deleteItem($event)",
    @switch="switchService($event)"
  )
</template>

<script>
import moment from "moment";
import { storeMixin } from "../mixins/storeMixin.js";
import EZToolbar from "../components/shared/EZToolbar.vue";
import ServiceDialog from "../components/dialogs/Service.vue";
export default {
  name: "services",
  mixins: [storeMixin],
  components: { EZToolbar, ServiceDialog },
  beforeMount() {
    this.ageTimer = setInterval(() => {
      if (!this.ageKey) this.ageKey = 1;
      this.ageKey *= -1;
    }, 60000);
    const serviceId = this.$route.params.serviceId;
    if (serviceId) {
      let service = this.sectionServices.find((s) => s.id === serviceId);
      if (!service) {
        setTimeout(() => {
          service = this.sectionServices.find((s) => s.id === serviceId);
          this.selectService(service);
          this.editItem(service);
        }, 1000);
      } else {
        this.selectService(service);
        this.editItem(service);
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.ageTimer);
  },
  data() {
    return {
      moment: moment,
      ageKey: 1,
      mode: {
        serviceDialog: false,
      },
      isRestaurantOpen: false,
      editedItem: {},
    };
  },
  computed: {
    serviceGroups() {
      return [
        {
          name: "Created",
          services: this.isRestaurantOpen
            ? this.draftRestaurantServices
            : this.draftSectionServices,
        },
        {
          name: "Active",
          services: this.isRestaurantOpen
            ? this.activeRestaurantServices
            : this.activeSectionServices,
        },
      ];
    },
  },
  methods: {
    getAge(service) {
      const age = Math.round((Date.now() - service.createdTS) / 60000);
      return age > 240 ? ">240" : age;
    },
    isDelayed(service) {
      const age = this.getAge(service);
      return isNaN(age) || age > 90;
    },
    openSection(section) {
      this.selectSection(section);
      this.isRestaurantOpen = false;
    },
    openRestaurant() {
      this.isRestaurantOpen = true;
    },
    editItem(service) {
      const section = this.sections.find((s) => s.id == service._sectionKey);
      this.selectSection(section);
      this.editedItem = Object.assign({}, service);
      this.mode.sectionCode = this.selectedSection.code;
      this.mode.serviceDialog = true;
    },
    addService() {
      this.editedItem = { _sectionKey: this.selectedSection.id };
      this.editedItem.tables = JSON.parse(
        JSON.stringify(this.selectedSection.tables)
      );
      this.mode.sectionCode = this.selectedSection.code;
      this.mode.serviceDialog = true;
    },
    save(payLoad) {
      if (payLoad.doc.id) {
        delete payLoad.doc.id;
        this.updateDoc(payLoad);
        payLoad.doc.id = payLoad.docId;
      } else {
        this.createDoc(payLoad);
      }
    },
    deleteItem(payLoad) {
      this.deleteDoc(payLoad);
    },
    switchService(serviceId) {
      const service = this.sectionServices.find((s) => s.id === serviceId);
      this.selectService(service);
      this.mode.tab = 2;
      this.editItem(service);
    },
  },
};
</script>
<style >
.blink {
  animation: blinkingText 1s infinite;
}
@keyframes blinkingText {
  0% {
    color: red;
  }
  50% {
    color: transparent;
  }
  100% {
    color: red;
  }
}
</style>
